import session from './session'

export default {
  config(projectID) {
    return session.get('/api/v1/bi_config/' + projectID)
  },
}
